import { Controller } from '@hotwired/stimulus';
import { post } from '@rails/request.js';
import { themeColor } from '@/utils/theme';

export default class extends Controller {
  static values = {
    playoutId: String,
    containerId: String,
    trackingUrl: String,
    resourceType: String,
    resourceId: String,
  };

  connect() {
    // eslint-disable-next-line no-undef
    const player = new js3q({
      dataid: this.playoutIdValue,
      container: `${this.containerIdValue}`,
      initialQuality: 480,
      playbackRateMenu: true,
      tintColor: themeColor(this.element, 'primary-900'),
      chromecast: false,
    });

    let hasStartedPlaying = false;

    player.on('media.playing', () => {
      if (!hasStartedPlaying && this.trackingUrlValue) {
        hasStartedPlaying = true;
        this.trackPlayEvent();
      }
    });
  }

  async trackPlayEvent() {
    await post(this.trackingUrlValue, {
      body: JSON.stringify({
        resource_type: this.resourceTypeValue,
        resource_id: this.resourceIdValue,
        resource_action: 'play',
      }),
    });
  }
}
